<div class="modal-header">
    <h4 class="modal-title text-black-50" style="color: black">{{title}}</h4>
</div>
<div class="modal-body">
    <p class="text-center" style="color: black;">
        {{description}}
    </p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-reset btn-cancel" (click)="onCancel()">Anuleaza</button>
    <button [disabled]="!isValid()" type="button" class="btn btn-danger"
            (click)="onSuccess()">Sunt sigur
    </button>
</div>
